import React, { useEffect, useState, useRef } from 'react';

const imgStyle = {
  position: 'absolute',
  width: 1,
  height: 1,
  opacity: 0.01,
  top: 0,
  left: 0,
}

function PreloadImages(props) {
  const [images, setImages] = useState([]);
  const [loaded, setLoaded] = useState([]);
  const timeoutRef = useRef(0);

  useEffect(() => {
    if (!props.images) return;
    showImgs();
    // eslint-disable-next-line
  }, [props.images]);

  const onImgLoad = (img) => {
    const l = [...loaded, img];
    setLoaded(l);
    showImgs(l);
    if (props.onImgLoad) {
      if (props.images.length) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
          props.onImgLoad(l.length / props.images.length);
        }, 500);
      }
    }
  }

  const showImgs = (l = loaded) => {
    const images = props.images.filter(i => l.indexOf(i) === -1).slice(0, 3);
    setImages(images);
  }

  return (
    <>
      {images.map(img => <img key={img} src={img} style={imgStyle} onLoad={() => onImgLoad(img)} />)}
    </>
  );
}

export default PreloadImages;